import React, { Component } from 'react';
import kwootLogoBlack from '../kwoot/logo-black.svg';
import './topbar.css';
import Link from 'react-router-dom/Link';
import Button from '../button/button';
import Projectcategories from '../projectcategories/projectcategories';
import Menutoggler from '../menutoggler/menutoggler';

class Topbar extends Component {

    render() {

        return (
            <div className="topbar">
                <div className="topbar__top">
                    <Menutoggler/>
                    <Button href="/contact" name="Neem contact op!" color="yellow" />

                </div>
                <div className="topbar__bottom">
                    <Link to="/" className="home"><img className="topbar__kwootLogoYellow" src={kwootLogoBlack} alt="Kwoot logo"/></Link>
                    <div className="onswerk__controls">
                        <h1>Waar we trots op zijn</h1>
                        <Projectcategories/>
                    </div>
                </div>
            </div>
        );
    }
}

export default Topbar;



// WEBPACK FOOTER //
// ./src/components/topbar/topbar.js